class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content =
      this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) === ''
    ) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    if (this.mainDetailsToggle.open) {
      const summary = this.mainDetailsToggle.querySelector('summary');
      const content = this.mainDetailsToggle.querySelector(
        '.mega-menu__content'
      );
      const list = content?.querySelector(
        '.mega-menu__list, .mega-menu__shop-columns'
      );
      if (summary && content && list) {
        const summaryRect = summary.getBoundingClientRect();
        const contentRect = content.getBoundingClientRect();
        const maxMargin = Math.round(contentRect.width - list.offsetWidth);
        let margin;
        if (list.classList.contains('mega-menu__shop-columns')) {
          margin = Math.round(triggerCenter - list.offsetWidth / 2);
        } else {
          margin = Math.round(summaryRect.left - contentRect.left);
        }
        list.style.marginLeft = `${Math.max(0, Math.min(margin, maxMargin)) - 8}px`;
      }
    }
  }
}

customElements.define('header-menu', HeaderMenu);
